import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { IWebRTCScreenCaptureDetails } from "src/app/interfaces/webRTC.interface";
import { TrsEventsService } from "src/app/services/trsevents.service";
import { WebRTCService } from "src/app/services/webrtc.service";

@Component({
    selector: 'webrtc-screen-selection-popup',
    templateUrl: './webrtc-screen-selection-popup.html',
    styleUrls: ['./webrtc-screen-selection-popup.sass'],
})
export class WebRTCScreenSelectionPopupComponent implements OnInit {
    @Input() AgentLanId: string;
    @Input() screenDetails: IWebRTCScreenCaptureDetails[];
    @Output() ClosePopUpEvent: EventEmitter<any> = new EventEmitter();

    maxSelectableScreens: number = 2;
    selectedScreenIds: Set<number> = new Set<number>();

    constructor(private translationService: TranslocoService, private trsEventService: TrsEventsService, public webrtcInfoService: WebRTCService) {
        this.updateComponentLabels();
    }

    screenshareHeaderLabel: string = "";
    closeLabel: string = "";

    ngOnInit(): void {
        this.updateComponentLabels();
    }

    updateComponentLabels = (): void => {
        this.screenshareHeaderLabel = this.translationService.translate("Select a screen to share");
        this.closeLabel = this.translationService.translate("Close");
    }

    closePopup = (): void => {
        this.sendEvent("CLOSE_SCREEN_SHARE_POPUP", this.AgentLanId);
        this.ClosePopUpEvent.emit("Close");
    }

    selectScreen = (id: number): void => {
        if (this.selectedScreenIds.has(id) === true)
            this.selectedScreenIds.delete(id);
        else {
            if (this.selectedScreenIds.size >= this.maxSelectableScreens)
                return;
            else this.selectedScreenIds.add(id);
        }
    }

    startCall = (): void => {
        this.sendEvent("START_SCREEN_SHARE_CALL", {
            AgentLanId: this.AgentLanId,
            SelectedScreenIds: Array.from(this.selectedScreenIds),
        });
        this.ClosePopUpEvent.emit("Close");
    }

    sendEvent = (eventName: any, responseData: any): void => this.trsEventService.evtdata.next({
        "eventName": eventName,
        "data": responseData,
    })
}